import { useMemo } from 'react';
import create from 'zustand';
var useEdgeworthPivotStore = create(function (set) { return ({
    currentPivot: undefined,
    setCurrentPivot: function (currentPivot) {
        set({ currentPivot: currentPivot });
    },
    stickyPivot: 'all',
    setStickyPivot: function (stickyPivot) {
        set({ stickyPivot: stickyPivot });
    },
}); });
export var useSingletonEdgeworthPivot = function () {
    var pivotStore = useEdgeworthPivotStore();
    return useMemo(function () { return ({
        currentPivot: pivotStore.currentPivot,
        setCurrentPivot: pivotStore.setCurrentPivot,
        stickyPivot: pivotStore.stickyPivot,
        setStickyPivot: pivotStore.setStickyPivot,
    }); }, [pivotStore]);
};
//# sourceMappingURL=useSingletonEdgeworthPivot.js.map